export default __webpack_public_path__ + "static/media/real_estate_web-md@1x.3e64b642.jpg";